import Repository from "./Repository";

const resource = "/avatars";

export default {
  get(part, headers) {
    return Repository.get(`${resource}/${part}`, { headers });
  },
};



// WEBPACK FOOTER //
// ./src/repositories/AvatarsRepository.js